import React from "react";
import "../styles/development.css";

export default function Development() {
  return (
    <div className="dev-page">

      {/* HERO */}
      <section className="dev-hero">
        <h1>विकास कामे</h1>
        <p>बेलपिंपळगाव – प्रगतीच्या दिशेने एक मजबूत पाऊल</p>
      </section>

      {/* INTRO */}
      <section className="dev-section intro">
        <h2>गावाचा सर्वांगीण विकास</h2>
        <p>
          बेलपिंपळगाव ग्रामपंचायत व सर्व ग्रामस्थांच्या सहकार्याने
          गावाच्या सर्वांगीण विकासासाठी विविध निर्णय, योजना व कामे
          राबवली जात आहेत.
        </p>
      </section>

      {/* GRAM SABHA RESOLUTIONS */}
      <section className="dev-section">
        <h2>ग्रामसभेने मंजूर केलेले ठराव</h2>
        <ol className="dev-list">
          <li>आई-वडिलांची काळजी न घेणाऱ्या मुलांची वारस नोंद रद्द करणे व पाणी व वीज कनेक्शन बंद करणे.</li>
          <li>मंदिर परिसरात फ्लेक्स बोर्ड व झेंडे लावण्यास बंदी; आवश्यक असल्यास ग्रामपंचायत व देवस्थान परवानगी आवश्यक.</li>
          <li>मंदिरावरील स्पीकरचा आवाज मर्यादित ठेवणे व परीक्षा काळात बंद ठेवणे.</li>
          <li>रस्त्यावर नळाचे पाणी आल्यास नोटीस देऊन नंतर कनेक्शन बंद करणे.</li>
          <li>हॉटेल व खाद्य व्यावसायिकांनी कचऱ्याची योग्य विल्हेवाट लावणे.</li>
          <li>सार्वजनिक मिरवणुकीत DJ वापरण्यास बंदी, परवानगी आवश्यक.</li>
          <li>थकबाकी प्रकरणे लोकअदालतीत ठेवणे.</li>
          <li>स्वर्गरथ वापरासाठी नियम लागू करणे.</li>
          <li>थकबाकी असलेल्या गाळा व्यावसायिकांचा करार रद्द करणे.</li>
          <li>रस्त्यावर वाळू, खडी, विटा टाकण्यास मनाई.</li>
          <li>शाळा सुटल्यानंतर रस्त्यावर बेदरकार वाहन चालवणाऱ्यांवर कारवाई.</li>
          <li>रस्त्यावरील अतिक्रमण स्वतःहून काढण्याचे आवाहन.</li>
          <li>शिक्षकांविषयी चुकीचे आरोप न करण्याबाबत निर्णय.</li>
          <li>सर्व सण, उत्सव व कार्यक्रम हे संपूर्ण गावाचे मानणे.</li>
        </ol>
      </section>

      {/* 15th FINANCE COMMISSION */}
      <section className="dev-section">
        <h2>१५ वा वित्त आयोग अंतर्गत कामे</h2>
        <ul className="dev-list">
          <li>समाजमंदिर तारकंपाउंड करणे</li>
          <li>ग्रामपंचायत कार्यालयासमोर पेव्हर ब्लॉक बसविणे</li>
          <li>अंगणवाडी संरक्षक जाळी बसविणे</li>
          <li>अंगणवाडी खडकी घोटाई करणे</li>
          <li>बलई वस्ती शाळा घोटाई करणे</li>
          <li>आदिवासी स्मशानभूमी तारकंपाउंड</li>
          <li>अमरधाम पत्रा शेड</li>
          <li>गावामध्ये CCTV बसविणे</li>
        </ul>
      </section>

      {/* PROPOSED WORKS */}
      <section className="dev-section">
        <h2>प्रस्तावित विकास कामे</h2>
        <ul className="dev-list">
          <li>तळ्यातील गाळ उपसणे व क्षमता वाढविणे</li>
          <li>जिल्हा परिषद शाळेसाठी नवीन इमारत</li>
          <li>बेलपिंपळगाव फाटा ते गाव रस्ता डांबरीकरण</li>
          <li>ग्रामीण रुग्णालय उभारणे</li>
          <li>छत्रपती शिवाजी महाराज पुतळा परिसर सुशोभीकरण</li>
          <li>गावठाण अंतर्गत नवीन केबल टाकणे</li>
          <li>पाझर तलाव बाराही महिने भरून ठेवणे</li>
          <li>सांस्कृतिक भवन उभारणे</li>
          <li>नवीन बाजारतळ व गावठाण रस्ते पेव्हर ब्लॉक</li>
          <li>विविध रस्त्यांचे डांबरीकरण</li>
          <li>दशक्रिया विधी स्थळी सुशोभीकरण व वृक्षारोपण</li>
          <li>पाणीपुरवठा विहिरीवर सोलर पॅनल</li>
          <li>शाळेवर सोलर पॅनल</li>
          <li>कॅनलवर पूल बांधणे</li>
          <li>मिनी मार्केट कमिटी स्थापन करणे</li>
          <li>नवीन दलित वस्त्या घोषित करणे</li>
          <li>सिंगल फेज वीज दुरुस्ती</li>
        </ul>
      </section>

      {/* MURUM & ROADS */}
      <section className="dev-section">
        <h2>मुरूमीकरण व शिवरस्ते</h2>
        <ul className="dev-list">
          <li>पाचेगाव – बेलपिंपळगाव शिवरस्ता</li>
          <li>साठे वस्ती ते पाचेगाव रस्ता</li>
          <li>कारवाडी वस्ती ते वरघुडे मळा</li>
          <li>घुमणदेव रस्ता ते विविध वस्त्या</li>
          <li>बेलपिंपळगाव ते थोरात वस्ती कच्चा रस्ता</li>
        </ul>
      </section>

      {/* MREGS */}
      <section className="dev-section">
        <h2>MREGS अंतर्गत कामे</h2>
        <ul className="dev-list">
          <li>गावतळे ते सूर्यभान कांगुणे ओढा गाळ काढणे</li>
          <li>बलई नाला गाळ काढणे</li>
          <li>भगत नाला गाळ काढणे</li>
        </ul>
      </section>

      {/* CTA */}
      
{/* NEW WORKS – STREET LIGHT & PAVER BLOCK */}
<section className="dev-section">
  <h2>नवीन मंजूर विकास कामे</h2>

  <ul className="dev-list">
    <li>बलई वस्ती येथे स्ट्रीट लाईट बसविणे</li>
    <li>झिंजुर्डे वस्ती येथे स्ट्रीट लाईट बसविणे</li>
    <li>झिंजुर्डे वस्ती येथे पेव्हर ब्लॉक बसविणे</li>
    <li>सुतार वस्ती येथे स्ट्रीट लाईट बसविणे</li>
    <li>सुतार वस्ती येथे रोड कॉकेट करणे</li>
    <li>सुरेगाव रोड येथे स्ट्रीट लाईट बसविणे</li>
  </ul>
</section>

{/* OTHER SCHEMES */}
<section className="dev-section">
  <h2>इतर योजना</h2>

  <ul className="dev-list">
    <li>जिल्हा नियोजन अंतर्गत अंगणवाडी – रोटे वस्ती</li>
    <li>शाळा खोल्या बांधणे</li>
    <li>जनसुविधा अंतर्गत स्ट्रीट लाईट बसविणे</li>
    <li>नागरी सुविधा अंतर्गत पेव्हर ब्लॉक बसविणे</li>
    <li>क वर्ग अंतर्गत स्ट्रीट लाईट बसविणे</li>
  </ul>
</section>
{/* UPCOMING WORKS */}
<section className="dev-section">
  <h2>पुढील नियोजित कामे</h2>

  <ul className="dev-list">
    <li>दशक्रिया विधीसाठी सुसज्ज घाट बांधणे</li>
    <li>गावामध्ये सुसज्ज वाचनालय उभारणे व UPSC / MPSC साठी आवश्यक पुस्तके उपलब्ध करणे</li>
    <li>प्रधानमंत्री आवास, रमाई आवास, शबरी आवास व मोदी आवास घरकुल योजनेंतर्गत लाभार्थ्यांना लवकरात लवकर लाभ मिळण्यासाठी शासन दरबारी पाठपुरावा करणे</li>
    <li>गावातील अधिकारी व पदाधिकाऱ्यांकडून इयत्ता १० वीच्या विद्यार्थ्यांसाठी व्याख्यानांचे आयोजन करणे</li>
    <li>गावातील तरुण विद्यार्थी व विद्यार्थिनींसाठी मार्गदर्शन व प्रेरणादायी शिबिरांचे आयोजन करणे</li>
  </ul>
</section>

    </div>
  );
}
